if (!customElements.get('recipient-form')) {
  customElements.define(
    'recipient-form',
    class RecipientForm extends HTMLElement {
      constructor() {
        super();
        this.recipientFieldsLiveRegion = this.querySelector(`#Recipient-fields-live-region-${this.dataset.sectionId}`);
        this.checkboxInput = this.querySelector(`#Recipient-checkbox-${this.dataset.sectionId}`);
        this.checkboxInput.disabled = false;
        this.hiddenControlField = this.querySelector(`#Recipient-control-${this.dataset.sectionId}`);
        this.hiddenControlField.disabled = true;
        this.emailInput = this.querySelector(`#Recipient-email-${this.dataset.sectionId}`);
        this.nameInput = this.querySelector(`#Recipient-name-${this.dataset.sectionId}`);
        this.senderNameInput = this.querySelector(`#Sender-name-${this.dataset.sectionId}`);
        this.whatsappInput = this.querySelector(`#Recipient-whatsapp-${this.dataset.sectionId}`);
        this.messageInput = this.querySelector(`#Recipient-message-${this.dataset.sectionId}`);
        this.sendonInput = this.querySelector(`#Recipient-send-on-${this.dataset.sectionId}`);
        this.offsetProperty = this.querySelector(`#Recipient-timezone-offset-${this.dataset.sectionId}`);
        if (this.offsetProperty) this.offsetProperty.value = new Date().getTimezoneOffset().toString();

        this.errorMessageWrapper = this.querySelector('.product-form__recipient-error-message-wrapper');
        this.errorMessageList = this.errorMessageWrapper?.querySelector('ul');
        this.errorMessage = this.errorMessageWrapper?.querySelector('.error-message');
        this.defaultErrorHeader = this.errorMessage?.innerText;
        this.currentProductVariantId = this.dataset.productVariantId;
        this.addEventListener('change', this.onChange.bind(this));
        this.onChange();

        const form = this.closest('form');
        const addToCartButton = form?.querySelector('[type="submit"]');

        addToCartButton?.addEventListener('click', (e) => {
          const errors = {};

          // Validate all fields together
          this.validateEmail(errors);       // validate email
          this.validateSenderName(errors);  // validate sender name
          this.validateWhatsapp(errors);    // validate WhatsApp number

          if (Object.keys(errors).length > 0) {
            e.preventDefault();             // stop add-to-cart
            e.stopPropagation();
            this.displayErrorMessage(this.defaultErrorHeader, errors);
            return false;
          }

          if (!this.checkboxInput.checked){
            return;
          } 

          const map = {
            '_gc_recipient_email': this.emailInput.value,
            '_gc_recipient_name': this.nameInput.value,
            '_gc_message': this.messageInput.value,
            '_gc_send_on': this.sendonInput.value
          };
          Object.entries(map).forEach(([key, value]) => {
            if (!value) return;
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = `properties[${key}]`;
            input.value = value;
            form.appendChild(input);
          });
          document.body.style.overflow = "auto";
        });
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;
      cartErrorUnsubscriber = undefined;

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
            this.resetRecipientForm();
          }
        });

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId === this.dataset.sectionId) {
            this.currentProductVariantId = event.data.variant.id.toString();
          }
        });

        this.cartErrorUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, (event) => {
          if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
            const errors = { ...(event.errors || {}) };
            this.validateSenderName(errors);
            this.validateWhatsapp(errors);
            this.validateEmail?.(errors);
            if (Object.keys(errors).length > 0) {
              this.displayErrorMessage(event.message, errors);
              return;
            }
          }
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }

        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }

        if (this.cartErrorUnsubscriber) {
          this.cartErrorUnsubscriber();
        }
      }

      validateSenderName(errors) {
        if (!this.senderNameInput || this.senderNameInput.disabled) return;
        if (!this.senderNameInput.value.trim()) {
          errors.sender_name = ['Sender Name is required'];
        }
      }

      validateWhatsapp(errors) {
        if (!this.whatsappInput || this.whatsappInput.disabled) return;
        const value = this.whatsappInput.value.trim();
        if (!/^[6-9][0-9]{9}$/.test(value)) {
          errors.whatsapp = ['Please enter a valid WhatsApp number'];
        }
      }

      validateEmail(errors) {
        if (!this.emailInput || this.emailInput.disabled) return;
        const value = this.emailInput.value.trim();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!value || !emailRegex.test(value)) {
          errors.email = ['Please enter a valid email'];
        }
      }

      onChange() {
        const hasErrors = this.errorMessageList && this.errorMessageList.querySelectorAll('li.error-message').length > 0;
        const qtySelectorWrapper = this.closest('.quantity-selector--wrapper');
        const qtySelectorWrapperSticky = this.closest(".quantity-selector--wrapper.sticky");
        const pdpBuyButtonsContainer = this.closest('.pdp-buttons-container');
        const customerRecipientForm = this.closest('.customer');
        const header = document.querySelector('.header-wrapper');
        const utilityBar = document.querySelector('.utility-bar ')
        const isMobile =
          window.matchMedia("(max-width: 767px)").matches &&
          ("ontouchstart" in window || navigator.maxTouchPoints > 0);
        if (this.checkboxInput.checked) {
          this.enableInputFields();
          this.recipientFieldsLiveRegion.innerText = window.accessibilityStrings.recipientFormExpanded;
          const isDesktop = window.matchMedia('(min-width: 750px)').matches;
            if(!hasErrors) {
              if (isDesktop && qtySelectorWrapper) {
                qtySelectorWrapper.style.marginBottom = '500px';
                if (qtySelectorWrapperSticky){
                  window.scrollTo({top: 300 , behavior: 'smooth'});
                }
              } else if (!isDesktop && pdpBuyButtonsContainer && customerRecipientForm) {
                pdpBuyButtonsContainer.style.paddingTop = '152%';
                customerRecipientForm.style.top = '2%';
                customerRecipientForm.style.bottom = '12%';
                customerRecipientForm.style.overflow = 'scroll';

                customerRecipientForm.style.padding = '0 12px';
                document.body.style.overflow = "hidden";
              }
            }
            if (isMobile){
              header.classList.add('hide-header');
              utilityBar.classList.add('hidden');
            }
        } else {
          this.clearInputFields();
          this.disableInputFields();
          this.clearErrorMessage();
          this.recipientFieldsLiveRegion.innerText = window.accessibilityStrings.recipientFormCollapsed;
          const isDesktop = window.matchMedia('(min-width: 750px)').matches;
          if (isDesktop && qtySelectorWrapper) {
            qtySelectorWrapper.style.marginBottom = '0px';
          } else if (!isDesktop && pdpBuyButtonsContainer && customerRecipientForm) {
            pdpBuyButtonsContainer.style.paddingTop = '50px';
            customerRecipientForm.style.top = '10%';
            customerRecipientForm.style.padding = '0 34px';
            document.body.style.overflow = "auto";
          }
            if (isMobile){
              header.classList.remove("hide-header");
              utilityBar.classList.remove('hidden');
            }
         }
       }

      inputFields() {
        return [this.emailInput, this.nameInput, this.senderNameInput, this.messageInput, this.sendonInput, this.whatsappInput];
      }

      disableableFields() {
        return [...this.inputFields(), this.offsetProperty];
      }

      clearInputFields() {
        this.inputFields().forEach((field) => (field.value = ''));
      }

      enableInputFields() {
        this.disableableFields().forEach((field) => (field.disabled = false));
      }

      disableInputFields() {
        this.disableableFields().forEach((field) => (field.disabled = true));
      }

      displayErrorMessage(title, body) {
        this.clearErrorMessage();
        this.errorMessageWrapper.hidden = false;
        if (typeof body === 'object') {
          this.errorMessage.innerText = this.defaultErrorHeader;
          return Object.entries(body).forEach(([key, value]) => {
            const errorMessageId = `RecipientForm-${key}-error-${this.dataset.sectionId}`;
            const fieldSelector = `#Recipient-${key}-${this.dataset.sectionId}`;
            const message = `${value.join(', ')}`;
            const errorMessageElement = this.querySelector(`#${errorMessageId}`);
            const errorTextElement = errorMessageElement?.querySelector('.error-message');
            if (!errorTextElement) return;

            if (this.errorMessageList) {
              this.errorMessageList.appendChild(this.createErrorListItem(fieldSelector, message));
            }

            // errorTextElement.innerText = `${message}.`;
            // errorMessageElement.classList.remove('hidden');

            // const inputElement = this[`${key}Input`];
            // if (!inputElement) return;

            // inputElement.setAttribute('aria-invalid', true);
            // inputElement.setAttribute('aria-describedby', errorMessageId);
          });
        }

        this.errorMessage.innerText = body;
      }

      createErrorListItem(target, message) {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.setAttribute('href', target);
        a.innerText = message;
        li.appendChild(a);
        li.className = 'error-message';

        // Apply spacing AFTER li is attached
        setTimeout(() => {
          const isDesktop = window.matchMedia('(min-width: 750px)').matches;

          const qtySelectorWrapper = this.closest('.quantity-selector--wrapper');
          const pdpBuyButtonsContainer = this.closest('.pdp-buttons-container');

          // Count how many <li> error messages exist
          const errorList = this.errorMessageList;
          const errorCount = errorList
            ? errorList.querySelectorAll('li.error-message').length
            : 1;

          const ERROR_LI_HEIGHT_PX = 25;      // each li height for desktop
          const ERROR_HEADING_HEIGHT_PX = 30; // fixed heading for desktop

          const ERROR_LI_HEIGHT_PERCENT = 6;      // each li height for mobile in %
          const ERROR_HEADING_HEIGHT_PERCENT = 9; // heading height for mobile in %

          if (isDesktop) {
            // DESKTOP → margin-bottom increase
            if (qtySelectorWrapper) {
              const baseMargin = 500; // default desktop margin from onChange()
              const totalExtra = ERROR_HEADING_HEIGHT_PX + (errorCount * ERROR_LI_HEIGHT_PX);
              qtySelectorWrapper.style.marginBottom = `${baseMargin + totalExtra}px`;
            }
          } else {
            // MOBILE → padding-top increase in %
            if (pdpBuyButtonsContainer) {
              const basePaddingPercent = 152; // default mobile padding-top in %
              const totalExtraPercent = ERROR_HEADING_HEIGHT_PERCENT + (errorCount * ERROR_LI_HEIGHT_PERCENT);
              pdpBuyButtonsContainer.style.paddingTop = `${basePaddingPercent + totalExtraPercent}%`;
            }
          }
        });
        return li;
      }


      clearErrorMessage() {
        this.errorMessageWrapper.hidden = true;

        if (this.errorMessageList) this.errorMessageList.innerHTML = '';

        this.querySelectorAll('.recipient-fields .form__message').forEach((field) => {
          field.classList.add('hidden');
          const textField = field.querySelector('.error-message');
          if (textField) textField.innerText = '';
        });

        [this.emailInput, this.messageInput, this.nameInput, this.senderNameInput, this.sendonInput, this.whatsappInput].forEach((inputElement) => {
          inputElement.setAttribute('aria-invalid', false);
          inputElement.removeAttribute('aria-describedby');
        });
      }

      applyCollapsedStyles() {
        const hasErrors = this.errorMessageList && this.errorMessageList.querySelectorAll('li.error-message').length > 0;
        const qtySelectorWrapper = this.closest('.quantity-selector--wrapper');
        const pdpBuyButtonsContainer = this.closest('.pdp-buttons-container');
        const customerRecipientForm = this.closest('.customer');

        const isDesktop = window.matchMedia('(min-width: 750px)').matches;

        // Only apply collapsed styling if there are no active errors
        if (!hasErrors) {
          if (isDesktop && qtySelectorWrapper) {
            qtySelectorWrapper.style.marginBottom = '0px';
          } else if (!isDesktop && pdpBuyButtonsContainer && customerRecipientForm) {
            pdpBuyButtonsContainer.style.paddingTop = '50px';
            customerRecipientForm.style.top = '10%';
            customerRecipientForm.style.padding = '0 34px';
          }
        }
      }

      resetRecipientForm() {
        if (this.checkboxInput.checked) {
          this.checkboxInput.checked = false;
          this.clearInputFields();
          this.clearErrorMessage();
        }
        this.applyCollapsedStyles();
      }
    }
  );
}


//DATE PICKER
document.addEventListener("DOMContentLoaded", function () {
  const dateInput = document.querySelector(".giftcard_date_input");
  const picker = document.querySelector(".date-picker__container");
  const closeBtn = document.querySelector(".date-picker__close-button");
  const confirmBtn = document.querySelector(".date-picker__confirm-button");
  const pickerOverlay = document.querySelector(".date-picker__overlay");
  const errorEl = document.querySelector(".date-picker__error");

  const dayWheel = document.querySelector('[data-type="day"]');
  const monthWheel = document.querySelector('[data-type="month"]');
  const yearWheel = document.querySelector('[data-type="year"]');

  if (!dateInput || !picker) return;

  const ITEM_HEIGHT = 36;
  const VISIBLE_ITEMS = 5;
  const BUFFER = 20;

  const months = [
    "January","February","March","April","May","June",
    "July","August","September","October","November","December"
  ];

const isMobile =
  window.matchMedia("(max-width: 767px)").matches &&
  ("ontouchstart" in window || navigator.maxTouchPoints > 0);

//   if (!isMobile) return;
  
  dateInput.setAttribute("readonly", true);

  function getSelectedDate() {
  const day = Number(highlightMiddle(dayWheel));
  const monthIndex = months.indexOf(highlightMiddle(monthWheel));
  const year = Number(highlightMiddle(yearWheel));

  return new Date(year, monthIndex, day);
}

function getToday() {
  const today = new Date();
  today.setHours(0, 0, 0, 0); // remove time
  return today;
}

function validateSelectedDate() {
  const selectedDate = getSelectedDate();
  const today = getToday();

  const isInvalid = selectedDate < today;

  confirmBtn.disabled = isInvalid;

  if (isInvalid) {
    errorEl?.classList.remove("hidden");
  } else {
    errorEl?.classList.add("hidden");
  }

  return !isInvalid;
}

function scrollWheelToValue(wheel, value, valuesArray) {
  const middleOffset = Math.floor(VISIBLE_ITEMS / 2);
  const items = [...wheel.children];

  // Find an index near the middle buffer
  const baseIndex = Math.floor(items.length / 2);
  const valueIndex = valuesArray.indexOf(value);

  if (valueIndex === -1) return;

  const targetIndex = baseIndex + valueIndex - middleOffset;
  wheel.scrollTop = targetIndex * ITEM_HEIGHT;

  highlightMiddle(wheel);
}

function preselectToday() {
  const today = new Date();

  const day = today.getDate();
  const month = months[today.getMonth()];
  const year = today.getFullYear();

  scrollWheelToValue(
    dayWheel,
    day,
    Array.from({ length: 31 }, (_, i) => i + 1)
  );

  scrollWheelToValue(monthWheel, month, months);

  scrollWheelToValue(
    yearWheel,
    year,
    Array.from({ length: 6 }, (_, i) => new Date().getFullYear() + i)
  );

  validateSelectedDate();
}


  function populateWheel(wheel, values) {
    wheel.innerHTML = "";

    const repeated = [];
    for (let i = 0; i < BUFFER; i++) {
      repeated.push(...values);
    }

    repeated.forEach(val => {
      const div = document.createElement("div");
      div.className = "wheel-item";
      div.textContent = val;
      wheel.appendChild(div);
    });

    wheel.scrollTop = Math.floor(repeated.length / 2) * ITEM_HEIGHT;
  }

  populateWheel(dayWheel, Array.from({ length: 31 }, (_, i) => i + 1));
  populateWheel(monthWheel, months);
  populateWheel(
    yearWheel,
    Array.from({ length: 1 }, (_, i) => new Date().getFullYear() + i)
  );

  function highlightMiddle(wheel) {
      const middleOffset = Math.floor(VISIBLE_ITEMS / 2);

  const centerIndex = Math.round(
    wheel.scrollTop / ITEM_HEIGHT
  ) + middleOffset;

    [...wheel.children].forEach(el => el.classList.remove("active"));
    const active = wheel.children[centerIndex];
    active?.classList.add("active");
    
    return active?.innerText;
  }

  function loopScroll(wheel, valuesLength) {
    const max = ITEM_HEIGHT * valuesLength * (BUFFER - 2);
    const min = ITEM_HEIGHT * valuesLength;

    if (wheel.scrollTop < min) {
      wheel.scrollTop += valuesLength * ITEM_HEIGHT;
    } else if (wheel.scrollTop > max) {
      wheel.scrollTop -= valuesLength * ITEM_HEIGHT;
    }
  }

function validateSelectedDate() {
  const selectedDate = getSelectedDate();
  const today = getToday();

  const isInvalid = selectedDate < today;

  confirmBtn.disabled = isInvalid;

  if (isInvalid) {
    errorEl?.classList.remove("hidden");
  } else {
    errorEl?.classList.add("hidden");
  }

  return !isInvalid;
}

function setupWheel(wheel, valuesLength) {
  wheel.addEventListener("scroll", () => {
    clearTimeout(wheel._t);

    loopScroll(wheel, valuesLength);
    highlightMiddle(wheel);
    validateSelectedDate();

    wheel._t = setTimeout(() => {
      wheel.scrollTop =
        Math.round(wheel.scrollTop / ITEM_HEIGHT) * ITEM_HEIGHT;
      highlightMiddle(wheel);
      validateSelectedDate();
    }, 80);
  });

  highlightMiddle(wheel);
  validateSelectedDate();
}


  setupWheel(dayWheel, 31);
  setupWheel(monthWheel, 12);
  setupWheel(yearWheel);

  function openPicker() {
    picker.classList.add("open");
    document.body.style.overflow = "hidden";
    if (!isMobile){
      pickerOverlay.classList.add("open-overlay");
    }
    preselectToday(); 
  }

  function closePicker() {
    picker.classList.remove("open");
    if (!isMobile){
      pickerOverlay.classList.remove("open-overlay");
      document.body.style.overflow = "auto";
    }
    else{
      document.body.style.overflow = "hidden";
    }
  }

  dateInput.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    openPicker();
  });

  closeBtn.addEventListener("click", closePicker);

confirmBtn.addEventListener("click", (evt) => {
  evt.preventDefault();
  evt.stopPropagation();

  if (!validateSelectedDate()) return;

  const day = highlightMiddle(dayWheel);
  const month = months.indexOf(highlightMiddle(monthWheel)) + 1;
  const year = highlightMiddle(yearWheel);

  dateInput.value =
    `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;

  closePicker();
});

});

